export default __webpack_public_path__ + "static/media/lunch.998004bc.svg";